import React from "react";
import ResMenuItems from "./menu/ResMenuItems";
import { useDispatch, useSelector } from "react-redux";
import { clearCart, removeItem } from "../store/cartSlice";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Cart = () => {
  const cartItems = useSelector((store) => store.cart.items);
  const dispatch = useDispatch();

  const handleClearCart = () => {
    dispatch(clearCart());
  };

  const handleRemoveItem = () => {
    dispatch(removeItem());
  };

  const handlePlaceOrder = () => {
    toast.success("Order has been placed successfully!", {
      position: "top-center",
      autoClose: 3000,
      
    });
    dispatch(clearCart());
  };
  

  const grandTotal = cartItems.reduce(
    (total, item) => total + (item?.card?.info?.price || item?.card?.info?.defaultPrice || 0),
    0
  ) / 100;

  const gst = +(grandTotal * 0.18).toFixed(2);
  const discount = +(grandTotal * 0.1).toFixed(2);
  const finalAmount = +(grandTotal + gst - discount).toFixed(2);

  return (
    <div className="my-[120px] text-center w-[95%] xs:w-[85%] sm:w-[75%] md:w-6/12 mx-auto bg-white p-2 xs:p-3 sm:p-5">
      {/* Cart Header */}
      <h1 className="font-bold p-2 xs:p-3 sm:p-5 text-blue-500 text-lg xs:text-xl sm:text-2xl border-b-2 border-gray-200">
        Cart Items
      </h1>

      {/* Cart Items */}
      <div className="my-2 xs:my-3 text-left">
        <ResMenuItems itemdata={cartItems} />
      </div>

      {/* Summary Section */}
      {cartItems.length === 0 ? (
        <div className="text-base xs:text-lg sm:text-xl">No food items added yet....</div>
      ) : (
        <div className="border-2 border-gray-200 pt-2 xs:pt-3 sm:pt-4 mt-2 xs:mt-3 sm:mt-4 text-left p-2 xs:p-3">
          <h2 className="font-bold text-base xs:text-lg sm:text-xl text-gray-700 mb-2 xs:mb-3">Summary</h2>
          <div className="flex justify-between text-sm xs:text-base">
            <p>Grand Total:</p>
            <p>₹{grandTotal}</p>
          </div>
          <div className="flex justify-between text-sm xs:text-base">
            <p>GST (18%):</p>
            <p>₹{gst}</p>
          </div>
          <div className="flex justify-between text-sm xs:text-base">
            <p>Discount (10%):</p>
            <p>-₹{discount}</p>
          </div>
          <div className="flex justify-between font-bold text-base xs:text-lg text-green-600 mt-2 xs:mt-3">
            <p>Final Amount:</p>
            <p>₹{finalAmount}</p>
          </div>
        </div>
      )}

      {/* Action Buttons */}
      {cartItems.length > 0 && (
        <div className="flex border-t-2 border-gray-200 justify-between pt-2 xs:pt-3 sm:pt-4 mt-2 xs:mt-3 sm:mt-4">
          <button
            onClick={handleClearCart}
            className="clear-cart-bttn px-2 xs:px-3 sm:px-4 py-1 xs:py-2 text-sm xs:text-base bg-red-500 text-white rounded shadow hover:bg-red-600 transition duration-300"
          >
            Clear Cart
          </button>

          <button
            onClick={handleRemoveItem}
            className="clear-cart-bttn px-2 xs:px-3 sm:px-4 py-1 xs:py-2 text-sm xs:text-base bg-yellow-500 text-white rounded shadow hover:bg-yellow-600 transition duration-300"
          >
            Remove Item
          </button>
        </div>
      )}

      {/* Place Order Button */}
      {cartItems.length > 0 && (
        <div className="flex justify-center mt-4">
          <button
            onClick={handlePlaceOrder}
            className="clear-cart-bttn px-2 xs:px-3 sm:px-4 py-1 xs:py-2 text-sm xs:text-base bg-yellow-500 text-white rounded shadow hover:bg-yellow-600 transition duration-300
             w-5/12"
          >
            Place Order
          </button>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default Cart;
